import api from "./api";

/* ------------------------------------------------------------ çevrimdışı yazma kuyruğu
   Yalnızca iş güncellemeleri (PUT /jobs/:id, JSON) bekletilir. İnternet gelince sırayla gönderilir. */
const QKEY = "sp_offline_queue";
const readQ = () => { try { return JSON.parse(localStorage.getItem(QKEY) || "[]"); } catch { return []; } };
const writeQ = (q) => { try { localStorage.setItem(QKEY, JSON.stringify(q)); } catch { /* dolu */ } window.dispatchEvent(new Event("sp-queue")); };
export const queueSize = () => readQ().length;
export const isQueueable = (cfg) => cfg && (cfg.method || "").toLowerCase() === "put" && /^\/jobs\/[^/]+$/.test(cfg.url || "") && typeof cfg.data === "string";
export function enqueue(cfg) {
  const q = readQ();
  const body = JSON.parse(cfg.data);
  const last = q[q.length - 1];
  if (last && last.url === cfg.url) last.body = { ...last.body, ...body };      // aynı iş: değişiklikleri birleştir
  else q.push({ url: cfg.url, body, at: Date.now() });
  writeQ(q);
}
let flushing = false;
export async function flushQueue() {
  if (flushing || !navigator.onLine) return 0;
  flushing = true; let ok = 0;
  try {
    let q = readQ();
    while (q.length) {
      const it = q[0];
      try { await api.put(it.url, it.body, { __noQueue: true }); q.shift(); ok++; writeQ(q); }
      catch (e) {
        if (!e.response) break;                       // hâlâ çevrimdışı
        q.shift(); writeQ(q);                          // sunucu reddetti (ör. iş kapanmış): kuyruktan at
        window.dispatchEvent(new CustomEvent("sp-queue-rejected", { detail: e.response?.data?.detail || "İşlem reddedildi" }));
      }
    }
  } finally { flushing = false; }
  return ok;
}
if (typeof window !== "undefined") {
  window.addEventListener("online", () => { flushQueue(); });
  setInterval(() => { if (queueSize()) flushQueue(); }, 30000);
}

/* ------------------------------------------------------------ web push */
const b64uToBytes = (s) => { const p = "=".repeat((4 - (s.length % 4)) % 4); const b = atob((s + p).replace(/-/g, "+").replace(/_/g, "/")); return Uint8Array.from([...b].map((c) => c.charCodeAt(0))); };
export const pushSupported = () => "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;
export async function pushStatus() {
  if (!pushSupported()) return "unsupported";
  if (Notification.permission === "denied") return "denied";
  const reg = await navigator.serviceWorker.getRegistration();
  const sub = reg && (await reg.pushManager.getSubscription());
  return sub ? "on" : "off";
}
export async function enablePush() {
  const perm = await Notification.requestPermission();
  if (perm !== "granted") throw new Error("Bildirim izni verilmedi");
  const reg = await navigator.serviceWorker.ready;
  const { data } = await api.get("/push/public-key");
  const sub = (await reg.pushManager.getSubscription()) || (await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: b64uToBytes(data.key) }));
  await api.post("/push/subscribe", sub.toJSON());
  return true;
}
export async function disablePush() {
  const reg = await navigator.serviceWorker.getRegistration();
  const sub = reg && (await reg.pushManager.getSubscription());
  if (sub) { try { await api.post("/push/unsubscribe", { endpoint: sub.endpoint }); } catch { /* */ } await sub.unsubscribe(); }
}
export function clearOfflineData() {
  try { localStorage.removeItem(QKEY); } catch { /* */ }
  if (navigator.serviceWorker?.controller) navigator.serviceWorker.controller.postMessage("clear-data");
}
